import { Parameter } from '@/stores/parameter/parameter-model';
import store from '@/stores/parameter/parameter-store';
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import DatasetStore from '@/stores/dataset/dataset-module';

@Module({ dynamic: true, namespaced: true, name: 'ParameterModule', store })
class ParameterModule extends VuexModule {
  private _selectedParameters: Parameter[] = [];

  public get allParameters(): Parameter[] {
    if (!DatasetStore.metadata) {
      return [];
    }
    return DatasetStore.metadata.parameters;
  }

  public get selectedParameters(): Parameter[] {
    return this._selectedParameters;
  }

  @Mutation
  updateSelectedParameters(parameters: Parameter[]): void {
    this._selectedParameters = parameters;
  }

  @Action({ commit: 'updateSelectedParameters' })
  addParametersToSelected(parameters: Parameter[]): Parameter[] {
    return [...this.selectedParameters, ...parameters];
  }
}

export default getModule(ParameterModule);
